<template>
  <div :ref="rowData.siteId" class="padded">
    <h3>{{utilLabel}} Bill Details</h3>

    <el-row :gutter="8">
      <el-col :sm="24" :md="canAccess('finance') ? 12 : 20">
      <table class="el-table">
        <thead>
          <tr>
            <th width="25%">Date</th>
            <th>{{formatDate(rowData.date)}}</th>
            <th v-if="showTax(isUtilTaxable)" style="text-align: center;">{{taxLabel}}</th>
          </tr>
        </thead>
<!--  // Keep just in case need to re-use
        <tfoot>
        <tr>
          <th colspan="3">Non-Refundable <i style="font-weight: normal;">per sharer</i></th>
        </tr>
        <tr>
          <td>Admin Charges</td>
          <td align="right">{{formatNumber(rowData.adminCharges)}}</td>
          <td align="right">{{formatNumber(adminTax)}}</td>
        </tr>
        <th colspan="3">Refundable <i style="font-weight: normal;">Total for all sharers</i></th>
      </tr>
      <tr>
        <td>Sharing Charges</td>
        <td align="right">{{formatNumber(rowData.total)}}</td>
        <td align="right">{{formatNumber(totalTax)}}</td>
      </tr>
       </tfoot>
-->
        <tbody>
          <tr>
            <th>Invoice No.</th>
            <td>{{rowData.invoiceNo}}</td>
            <td></td>
          </tr>
          <tr>
            <th>Period</th>
            <td>{{formatDate(rowData.periodFrom)}}</td>
            <td>{{formatDate(rowData.periodTo)}}</td>
          </tr>
          <tr>
            <th>{{overdueLabel}}</th>
            <td align="right">{{formatNumber(rowData.arrears)}}</td>
            <td align="right"></td>
          </tr>
          <tr>
            <th>{{amountLabel}}</th>
            <td align="right">{{formatNumber(rowData.amount)}}</td>
            <td v-if="showTax(isUtilTaxable)" align="right">{{formatNumber(rowData.tax)}}</td>
            <td v-else></td>
          </tr>
          <tr>
            <th>Penalties</th>
            <td align="right">{{formatNumber(rowData.penalty)}}</td>
            <td></td>
          </tr>
          <tr v-if="showTax(isUtilTaxable)">
            <th>Un-taxed charges</th>
            <td align="right">{{formatNumber(rowData.untaxedCharges)}}</td>
            <td></td>
          </tr>
          <tr>
            <th>{{extraChargesLabel}}</th>
            <td align="right">{{formatNumber(rowData.extraCharges)}}</td>
            <td align="right"></td>
          </tr>
          <tr>
            <th>Rounding Adjustment</th>
            <td align="right">{{formatNumber(rowData.rounding)}}</td>
            <td align="right"></td>
          </tr>
          <tr>
            <th>TOTAL</th>
            <td align="right">{{formatNumber(rowData.total)}}</td>
            <td v-if="showTax(isUtilTaxable)" align="right">{{formatNumber(rowData.tax)}}</td>
            <td v-else></td>
          </tr>
        </tbody>
      </table>
     </el-col>

     <el-col v-if="canAccess('finance')" :sm="24" :md="10" :offset="2">
       <el-form  :model="form"  label-width="120px">

         <table class="el-table">
           <tr>
             <th>Paid?</th>
             <td v-if="!rowData.paid">
               <switch-input  on-text="Yes" off-text="No"
               v-model="form.paid"
               @change="onPaid" />
             </td>
             <td v-else  align="center"><span class="text-success">Yes</span></td>
           </tr>

           <tr>
             <th>Date Paid</th>
             <td v-if="!rowData.paid">
               <date-input v-model="form.paidDate" placeholder="Paid Date"
                 :disabled="!form.paid" />
             </td>
             <td v-else align="right">
               <strong>{{this.formatDate(this.rowData.paidDate)}}</strong>
             </td>
           </tr>

           <tr>
             <th>Ref</th>
             <td v-if="!rowData.paid">
               <text-input v-model="form.paidRef" placeholder="Paid Ref"
               :disabled="!form.paid" />
             </td>
             <td v-else  align="right">
               <strong>{{this.rowData.paidRef}}</strong>
             </td>
           </tr>

           <tr>
             <th>Amount</th>
             <td v-if="!rowData.paid">
               <currency-input v-model="form.amountPaid" :disabled="!form.paid" />
             </td>
             <td v-else  align="right">
               <strong>{{this.formatNumber(this.rowData.amountPaid)}}</strong>
             </td>
           </tr>

           <tr v-if="showTax(isUtilTaxable) && (form.taxPaid && form.taxPaid > 0)">
             <th>{{taxLabel}}</th>
             <td v-if="!rowData.paid">
               <currency-input v-model="form.taxPaid" :disabled="!form.paid" />
               <span v-if="!paidSubmit && !rowData.paid">{{tax}}</span>
             </td>
             <td v-else  align="right">
               <strong>{{this.formatNumber(this.rowData.taxPaid)}}</strong>
             </td>
           </tr>

           <tr>
             <th>Total</th>
             <td align="right">
               {{currency}}<b>{{this.formatNumber(totalPaid)}}</b>
             </td>
           </tr>

           <tr v-if="outstanding && outstanding !== '0.00'">
            <th>O/S</th>
            <td  align="right">
              <span class="text-danger">{{this.outstanding}}</span>
            </td>
           </tr>

           <tr v-if="!paidSubmit && !rowData.paid">
             <td></td>
             <td>
               <el-button type="success" @click="onSubmit"
              :disabled="payable && !paidSubmit">Save</el-button>
            </td>
           </tr>

         </table>

       </el-form>

     </el-col>
    </el-row>

    <br />

    <el-row>
      <utility-sharing-table :row-data="rowData" :site="site" />
    </el-row>

    <el-col v-if="rowData && rowData.updated_at" align="right" :span="24">
        <small>Last Update </small>
        <strong>{{formatFriendlyDate (rowData.updated_at)}}</strong><span v-if="rowData.updated_by"> by {{rowData.updated_by}}</span>
    </el-col>


  </div>
</template>

<script>

import Vue from 'vue'
import VueEvents from 'vue-events'

Vue.use(VueEvents)

import {settings} from '@/components/Data'

import DateMixins from '@/mixins/DateMixins'
import NumberMixins from '@/mixins/NumberMixins'
import PostMixins from '@/mixins/PostMixins'

import UtilitySharingTable from '@/components/utility/UtilitySharingTable'

export default {
  mixins: [DateMixins, NumberMixins, PostMixins],

  components: {
    UtilitySharingTable
  },

  props: {
    rowData: {
      type: Object,
      required: true
    },

    tableRef: {
      type: String,
      default: 'utiltable'
    },

    site: {
      type: Object,
      default: null
    }
  },

  methods: {
    onPaid () {
      if (this.form.paid) {
        if (!this.form.amountPaid || this.form.amountPaid === 0) {
          this.form.amountPaid = this.form.total
        }
      }

      if (!this.form.paidDate) {
        this.form.paidDate = new Date()
      }
    },

    onSubmit () {
      this.form.paidDate = this.formatDateSql(this.form.paidDate)
      this.saveForm(this, '/utility', this.form.id, this.form, 'Paid ' + this.utilLabel + ' bill', this.success)
    },

    success (response) {
      this.paidSubmit = true  // TODO need to refresh totals on Summary page.
      this.$events.fire(this.tableRef + '-refresh-table')
    }

  },

  computed: {

    payable () {
      return (!this.form.paidDate || !this.form.amountPaid)
    },

    adminTax () {
      return this.taxDue(this.form.adminCharges, this.isUtilTaxable)
    },

    tax () {
      if (this.form.paid) {
        return this.formatNumber(this.taxDue(this.form.amountPaid, this.isUtilTaxable))
      } else {
        return 0
      }
    },

    totalPaid () {
      this.form.totalPaid = this.totalDue(this.form.amountPaid, this.form.taxPaid)
      return this.form.totalPaid
    },

    outstanding () {
      if (this.form.paid) {
        return this.formatNumber(this.form.totalPaid - this.form.total)
      } else {
        return null
      }
    },

    outstandingTax () {
      if (this.form.paid) {
        return this.formatNumber(this.form.taxPaid - this.form.tax)
      } else {
        return null
      }
    }

  },

  data () {

    return {
      format: settings.selectDateFormat,
      currency: settings.currency,
      utilLabel: this.getUtilLabel(this.rowData),
      isUtilTaxable: settings.utilTaxable,
      taxLabel: settings.taxName,
      overdueLabel: settings.utilOverdueLabel,
      amountLabel: settings.utilAmountLabel,
      extraChargesLabel: settings.utilExtraInputLabel,
      extraCalcTotal: settings.utilExtraInputTotal,
      paidSubmit: false,
      paidFlag: this.rowData.paid,
      form: this.clone(this.rowData),
      rates: []
    }

  },

  mounted () {
    this.paidSubmit = !this.payable
//    console.log('isUtilTaxable', this.isUtilTaxable, 'showTax', this.showTax(!this.isUtilTaxable))
  }
}
</script>
